import type { GetRecentOrders200OrdersItem } from './getRecentOrders200OrdersItem';

export type GetRecentOrders200 = {
  message?: string;
  orders?: GetRecentOrders200OrdersItem[];
  success: boolean;
};
